import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import LOOKUP from 'constants/lookup';
import {
    addPaymentToOrder, clearTax, addShippingCost, addRefundOrder, sendOrderToFulFillment, giftCardPurchase, paystoneGiftCardPurchase,
    birchmountGiftCardPurchase, alpineIQviewWallet, addTipAmount, chargeGiftCard, checkOrderUpdateTime, clearPriceMatchRows, getManagerApproval, adyenPaymentRequest, adyenRefundRequest
} from 'actions/EntityActions';
import { formInput, formError } from 'actions/FormActions';
import CustomButton from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';
import SelectInput from 'screens/components/basic/SelectInput';
import TextInput from 'screens/components/basic/TextInput';
import util from 'library/util';
import POSDiscountDialog from './POSDiscountDialog';
import POSRemoveDiscountDialog from './POSRemoveDiscountDialog';
import POSRefundDialog from './POSRefundDialog';
import POSAddShippingCostDialog from './POSAddShippingCostDialog';
import POSAddTipAmountDialog from './POSAddTipAmountDialog';
import POSCardPaymentStatusDialog from './POSCardPaymentStatusDialog'
import { OrderProductStatus, CardAccountType, CardType, LanguageCode } from 'constants/enums';
import { selectRefundProducts, giftCardPaymentModel } from 'selectors/entitySelector';
import { PurchaseOrReturn } from 'constants/enums';
import ToggleInput from 'screens/components/basic/ToggleInput';
import { showSnackbar, showError } from 'actions/CommonActions';
import { Button, Paper, TextField, Dialog, CircularProgress, DialogContent } from '@mui/material';
import { getToken } from 'selectors/tokenSelector';
import { isToday } from 'utils/helpers';


const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    padding: '30px'
};

const NoCardType = 0;

const problemBtnShowTime = 10000;

class POSPayment extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedPaymentMethod: null,
            dialogDiscount: false,
            dialogRemoveDiscount: false,
            dialogRefund: false,
            loading: false,
            dialogAddShippingCost: false,
            dialogAddTipAmount: false,
            picType: "None",
            globalType: "None",
            posCardPaymentStatusDialog: false,
            showProductBtn: false,
            showToolTip: false,
            payfirmaRefundDialog: false,
            formattedCardNumber: "",
            giftCardProcessError: false
        };
        this.receiptUrl = null;
        this.receiptId = null;
        this.purchaseOrReturn = null;
        this.getAmpResponseInterval = null;
        this.getMonerisInterval = null;
        this.getPaystoneResponseInterval = null;
    }

    componentWillReceiveProps(newProps) {
        if (newProps.posCreated !== null && newProps.posCreated !== undefined && newProps.posCreated !== this.props.posCreated) {
            if (newProps.posOrder.status == 'Completed' || newProps.posOrder.balanceDue <= 0) {
                this.props.printReceipt(newProps.posOrder, this.props.numberOfCopies);
            }
        }

        // pic payment result handle
        if (newProps.picStatus !== null && newProps.picStatus !== undefined && newProps.picStatus !== this.props.picStatus) {
            if (newProps.picStatus.includes("Approved") && this.state.picType == "P") {
                // this is for new service
                if (newProps.picStatus.split(',').length > 3) {
                    let cardType = newProps.picStatus.split(',')[2];
                    let tipAmount = newProps.picStatus.split(',')[3];
                    // adjust payment method if needed, and set card type
                    let paymentType = "Credit";
                    let picCardType = 0;
                    if (cardType) {
                        if (cardType.toUpperCase() == 'DEBIT') {
                            paymentType = "Debit";
                        } else if (cardType.toUpperCase() == 'VISA') {
                            picCardType = 1;
                        } else if (cardType.toUpperCase() == 'MASTERCARD') {
                            picCardType = 2;
                        } else if (cardType.toUpperCase() == 'AMEX') {
                            picCardType = 3;
                        }
                    }
                    let paymentIdByType = this.getPaymentIdByType(paymentType);
                    this.finishCardPayment(null, this.receiptId, false, null, paymentIdByType, tipAmount / 100, picCardType);
                }
                // this is for old service
                else {
                    this.finishCardPayment(null, this.receiptId);
                }
            } else if (newProps.picStatus.includes("Approved") && this.state.picType == "R") {
                // this is for new service
                if (newProps.picStatus.split(',').length > 2) {
                    let cardType = newProps.picStatus.split(',')[2];
                    let picCardType = 0;
                    if (cardType) {
                        if (cardType.toUpperCase() == 'VISA') {
                            picCardType = 1;
                        } else if (cardType.toUpperCase() == 'MASTERCARD') {
                            picCardType = 2;
                        } else if (cardType.toUpperCase() == 'AMEX') {
                            picCardType = 3;
                        }
                    }
                    let modelToUse = newProps.model;
                    modelToUse.CardType = picCardType;
                    this.props.addRefund(newProps.posOrder.id, modelToUse);
                }
                // this is for old service
                else {
                    this.props.addRefund(newProps.posOrder.id, newProps.model);
                }
            }
            this.setState({
                loading: false
            });
            console.log(newProps.picStatus);
        }

        //global payment result handle
        if (newProps.globalStatus !== null && newProps.globalStatus !== undefined && newProps.globalStatus !== this.props.globalStatus) {
            if (newProps.globalStatus.split(',').length > 3) {
                let responseCode = newProps.globalStatus.split(',')[1];
                if (responseCode == "00" || responseCode == "0") {
                    let referenceNumber = newProps.globalStatus.split(',')[2];
                    let cardType = newProps.globalStatus.split(',')[3];
                    let tipAmount = newProps.globalStatus.split(',')[4];
                    // adjust payment method if needed, and set card type
                    let paymentType = "Credit";
                    let globalCardType = 0;
                    if (cardType) {
                        if (cardType.toUpperCase() == 'DEBIT') {
                            paymentType = "Debit";
                        } else if (cardType.toUpperCase() == 'VISA') {
                            globalCardType = 1;
                        } else if (cardType.toUpperCase() == 'MASTERCARD') {
                            globalCardType = 2;
                        } else if (cardType.toUpperCase() == 'AMEX') {
                            globalCardType = 3;
                        }
                    }
                    if (this.state.globalType == "P") {
                        let paymentIdByType = this.getPaymentIdByType(paymentType);
                        this.finishCardPayment(null, referenceNumber, false, null, paymentIdByType, tipAmount, globalCardType);
                    } else if (this.state.globalType == "R") {
                        let modelToUse = newProps.model;
                        modelToUse.CardType = globalCardType;
                        this.props.addRefund(newProps.posOrder.id, modelToUse);
                    }
                }
            }

            this.setState({
                loading: false
            });
        }

        if (newProps.giftCardPurchaseTime != null && newProps.giftCardPurchaseTime !== this.props.giftCardPurchaseTime) {
            this.finishCardPayment(newProps.giftCardPurchaseResponse.txnNumber, newProps.giftCardPurchaseResponse.receiptId, false, newProps.giftCardPurchaseResponse.benefitAmount);
        }

        if (newProps.paystoneGiftCardPurchaseTime !== null && newProps.paystoneGiftCardPurchaseTime !== undefined && newProps.paystoneGiftCardPurchaseTime !== this.props.paystoneGiftCardPurchaseTime) {
            this.finishCardPayment(newProps.paystoneGiftCardPurchaseData.tcn, newProps.paystoneGiftCardPurchaseData.invoiceNumber, false, newProps.paystoneGiftCardPurchaseData.requestAmount);
            this.props.printPaystoneGiftCardReceipt(newProps.paystoneGiftCardPurchaseData);
        }

        if (newProps.birchmountGiftCardPurchaseTime !== null && newProps.birchmountGiftCardPurchaseTime !== undefined && newProps.birchmountGiftCardPurchaseTime !== this.props.birchmountGiftCardPurchaseTime) {
            this.finishCardPayment(newProps.birchmountGiftCardPurchaseData.response.transactioN_ID, null, false, null);
            this.props.printBirchmountGiftCardReceipt(newProps.birchmountGiftCardPurchaseData.response);
        }

        if (newProps.sendToFulfillmentSuccess !== null && newProps.sendToFulfillmentSuccess !== undefined && newProps.sendToFulfillmentSuccess !== this.props.sendToFulfillmentSuccess) {
            this.props.ToggleClosePayment();
        }

        if (newProps.adyenPaymentSuccessTime !== null && newProps.adyenPaymentSuccessTime !== undefined && newProps.adyenPaymentSuccessTime !== this.props.adyenPaymentSuccessTime) {
            this.setState({
                loading: false
            });
            if (newProps.adyenPaymentResponse.result === "Success") {
                this.finishCardPayment(newProps.adyenPaymentResponse.timeStamp, newProps.adyenPaymentResponse.transactionID, false, null);
            } else {
                this.props.showError("payment failed");
            }
        }

        if (newProps.adyenRefundSuccessTime !== null && newProps.adyenRefundSuccessTime !== undefined && newProps.adyenRefundSuccessTime !== this.props.adyenRefundSuccessTime) {
            this.setState({
                loading: false
            });
            if (newProps.adyenRefundResponse.result === "Success") {
                let model = this.props.model;
                model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                this.props.addRefund(newProps.posOrder.id, model);
            } else {
                this.props.showError("refund failed");
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.giftCardPurchaseFailResponseTime &&
            (this.props.giftCardPurchaseFailResponseTime !== prevProps.giftCardPurchaseFailResponseTime)) {
            this.displayGiftCardError();
            this.clearGiftCardForm();
        }

        if (this.props.giftCardPurchaseSuccessResponseTime &&
            (this.props.giftCardPurchaseSuccessResponseTime !== prevProps.giftCardPurchaseSuccessResponseTime)) {
            this.clearGiftCardForm();
            const paymentAmount = this.props.giftCardPurchaseSuccessResponse.paymentAmount;
            this.finishCardPayment(null, null, false, paymentAmount);
        }

        if (this.props.posOrderCheckUpateTimePassed &&
            (this.props.posOrderCheckUpateTimePassed !== prevProps.posOrderCheckUpateTimePassed)) {
            this.confirmPayment();
        }

        if (this.props.managerApprovalTimeStamp !== null && prevProps.managerApprovalTimeStamp !== this.props.managerApprovalTimeStamp) {

            if (this.props.managerApprovalSuccess) {
                this.cardApproved();
            } else {
                this.props.showError(this.props.t('pos.messages.invalidCredentialsAllowOption'));
            }
        }
    }

    clearGiftCardForm = () => {
        this.props.formInput("", "POSGiftCardCardNumber")
        this.props.formInput("", "POSGiftCardAmount")
        this.setState({ formattedCardNumber: "" })
    }

    onPaymentSelect = (paymentMethod) => {
        this.props.formInput("", 'picStatus');
        this.setState({ selectedPaymentMethod: paymentMethod });
        if (!paymentMethod) {
            this.props.formInput(null, `${this.props.name}Amount`);
            this.props.formInput(null, `${this.props.name}ReceiptNumber`);
            this.props.formInput(null, `${this.props.name}StoreCreditCode`);
            this.props.formInput(null, `${this.props.name}CardType`);
            this.props.formInput(null, `${this.props.name}GiftCardNumber`);
            this.props.formInput(null, `${this.props.name}GiftCardExpireDate`);
            this.props.formInput(null, `${this.props.name}GiftCardCvdValue`);
            this.props.formInput(null, `POSGiftCardCardNumber`);
            this.props.formInput("", "POSGiftCardAmount")
            this.setState({ formattedCardNumber: "" })
        } else {
            if (paymentMethod.name === "Debit") {
                this.props.formInput(this.props.posOrder ? this.props.posOrder.balanceDue.toFixed(2).toString() : null, `${this.props.name}Amount`);
            }
            else if (paymentMethod.name === "Credit") {
                this.props.formInput(this.props.posOrder ? this.props.posOrder.balanceDue.toFixed(2).toString() : null, `${this.props.name}Amount`);
            }
            else if (paymentMethod.name === "Cash") {
                this.props.formInput(null, `${this.props.name}Amount`);
            }
            else if (paymentMethod.name === "StoreCredit") {
                this.props.formInput(null, `${this.props.name}Amount`);
            }
            else if (paymentMethod.name === "GiftCard" && this.props.genericGiftCardEnabled) {
                this.props.formInput(null, `POSGiftCardCardNumber`);
                this.props.formInput("", "POSGiftCardAmount")
                this.setState({ formattedCardNumber: "" })
            }
            else if (paymentMethod.name === "GiftCard") {
                this.props.formInput(this.props.posOrder ? this.props.posOrder.balanceDue.toFixed(2).toString() : null, `${this.props.name}Amount`);
            }
            else if (paymentMethod.name === "Online") {
                this.props.formInput(this.props.posOrder ? this.props.posOrder.balanceDue.toFixed(2).toString() : null, `${this.props.name}Amount`);
            }
        }
    }

    openAddShippingCostDialog = () => {
        this.props.formInput(this.props.posOrder.shippingCost.toFixed(2), `posDialogAddShippingCostValue`);
        this.setState({ dialogAddShippingCost: true });
    }

    closeAddShippingCostDialog = () => {
        this.setState({ dialogAddShippingCost: false });
    }

    openAddTipAmountDialog = () => {
        this.props.formInput((this.props.posOrder.tipAmount ? this.props.posOrder.tipAmount : 0).toFixed(2), `posDialogAddTipAmountValue`);
        this.setState({ dialogAddTipAmount: true });
    }

    closeAddTipAmountDialog = () => {
        this.setState({ dialogAddTipAmount: false });
    }

    openRemoveDiscountDialog = () => {
        this.setState({ dialogRemoveDiscount: true });
    }

    closeRemoveDiscountDialog = () => {
        this.setState({ dialogRemoveDiscount: false });
    }

    openDiscountDialog = () => {
        if (this.props.posOrder) {
            if (this.props.alpineIQwalletCode && (this.props.wallet == null || this.props.wallet == undefined || this.props.wallet.length == 0)) {
                this.props.alpineIQviewWallet({
                    phoneNumber: this.props.posOrder.patientPhoneNumber, branchId: this.props.branchId, code: this.props.alpineIQwalletCode, email: this.props.posOrder.patientEmail
                });
            }
        }
        this.setState({ dialogDiscount: true });
        window.removeEventListener("keypress", this.props.barcodeListener);
    }

    closeDiscountDialog = () => {
        this.setState({ dialogDiscount: false });
        window.addEventListener("keypress", this.props.barcodeListener);
    }

    openRefundDialog = () => {
        const showToolTip = this.props.posOrder ? (this.props.posOrder.products.filter(item => item.isRefundable && item.status === 2 && item.qtyAvaibleForRefund > 0).length === 0) : true;

        if (showToolTip) {
            this.setState({ showToolTip: true });
            setTimeout(function () {
                this.setState({ showToolTip: false });
            }.bind(this), 10000)
        } else {
            this.setState({ dialogRefund: true });
        }
    }

    closeRefundDialog = () => {
        this.setState({ dialogRefund: false });
    }

    closePayfirmaRefundDialog = () => {
        this.setState({ payfirmaRefundDialog: false });
    }

    confirmPayfirmaRefund = () => {
        this.setState({ payfirmaRefundDialog: false });
        let model = this.props.model;
        model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
        this.props.addRefund(this.props.posOrder.id, model);
    }

    addToAmount = (amount) => {
        let currentAmount = 0;
        if (typeof amount === "number") {
            currentAmount = +this.props.amount + +amount;
        } else if (typeof amount === "string" && amount === "exactCash") {
            currentAmount = +this.props.order.balanceDue;
        }
        this.props.formInput(currentAmount.toFixed(2).toString(), `${this.props.name}Amount`);
    }

    getReceiptUrl = (type, cardOrderId = null, cardTxnNumber = null, amount = null) => {
        let model = {};
        // P stands for PURCHASE
        if (type == "P") {
            this.purchaseOrReturn = PurchaseOrReturn.Purchase;
            this.receiptId = this.props.store.monerisStoreId + this.props.posOrder.id.toString() + "r" + Math.floor(Math.random() * 100);
            model = {
                branchId: this.props.branchId,
                terminalId: this.props.pinPadId,
                txnType: "purchase",
                request: {
                    amount: this.props.amount.toFixed(2),
                    orderId: this.receiptId
                }
            };

            fetch(this.props.store.apiUrl + "unauthorized/logDataToMoneris", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            });

            this.setState({
                loading: true
            });
            setTimeout(() => {
                this.setState({ showProductBtn: true });
            }, problemBtnShowTime);
            console.log(model);
            return fetch(this.props.store.posAPIUrl + "unauthorized/postDataToMoneris", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    return data.data;
                });
        }
        // R stands for REFUND
        else if (type == 'R') {
            this.purchaseOrReturn = PurchaseOrReturn.Return;
            model = {
                branchId: this.props.branchId,
                terminalId: this.props.pinPadId,
                txnType: "refund",
                request: {
                    txnNumber: cardTxnNumber,
                    orderId: cardOrderId,
                    amount: amount
                }
            };

            fetch(this.props.store.apiUrl + "unauthorized/logDataToMoneris", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            });

            this.setState({
                loading: true
            });
            setTimeout(() => {
                this.setState({ showProductBtn: true });
            }, problemBtnShowTime)
            console.log(model);
            return fetch(this.props.store.posAPIUrl + "unauthorized/postRefundDataToMoneris", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    return data.data;
                });
        }
    }

    checkUrlInterval = (url) => {
        this.receiptUrl = url;
        this.getMonerisInterval = setInterval(this.checkUrl, 2000);
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    getPaymentIdByType = (type) => {
        let payment = this.props.payments.find(_ => _.name === type && _.branchId === this.props.branchId && (_.status == "1" || _.status == "Active"));
        if (payment && payment.id !== this.state.selectedPaymentMethod.id) {
            return payment.id;
        }

        return 0;
    }

    checkUrl = () => {
        fetch(this.receiptUrl)
            .then(res => res.json())
            .then((result) => {
                console.log(result);
                if (result.receipt.Completed !== "false" || result.receipt.Error == "true") {
                    this.saveMonerisResponseTodb(result);
                    clearInterval(this.getMonerisInterval);
                    this.setState({
                        loading: false,
                        posCardPaymentStatusDialog: false,
                        showProductBtn: false
                    });
                    if (result.receipt.Error == "true" && result.receipt.Completed == "false") { }
                    else if (result.receipt.Error == "false" && result.receipt.Completed == "true") {
                        const model = {
                            TranscationType: result.receipt.TransType,
                            AccountType: CardAccountType[result.receipt.AccountType],
                            Amount: result.receipt.Amount,
                            CardType: CardType[result.receipt.CardType],
                            CardNumber: result.receipt.Pan,
                            CardName: result.receipt.CardName,
                            TranscationDate: result.receipt.TransDate,
                            TranscationTime: result.receipt.TransTime,
                            Reference: result.receipt.ReferenceNumber,
                            ResponseCode: result.receipt.ResponseCode,
                            ISO: result.receipt.ISO,
                            AuthCode: result.receipt.AuthCode,
                            AppLabel: result.receipt.AppLabel,
                            AppPreferredName: result.receipt.AppPreferredName,
                            Aid: result.receipt.Aid,
                            TvrArqc: result.receipt.TvrArqc,
                            TvrTcacc: result.receipt.TvrTcacc,
                            Tsi: result.receipt.Tsi,
                            CvmIndicator: result.receipt.CvmIndicator,
                            SwipeIndicator: result.receipt.SwipeIndicator,
                            LanguageCode: LanguageCode[result.receipt.LanguageCode],
                            InvoiceNumber: result.receipt.InvoiceNumber,
                            FFDT: result.receipt.FormFactor
                        }
                        this.props.printCredit(model);
                        if (parseInt(result.receipt.ResponseCode) < 50) {
                            console.log("the payment has completed and success.");
                            let creditCardType = 0;
                            if (model.CardType == 'Visa') {
                                creditCardType = 1;
                            } else if (model.CardType == 'MasterCard') {
                                creditCardType = 2;
                            } else if (model.CardType == 'American Express') {
                                creditCardType = 3;
                            }

                            if (result.receipt.TxnName == "Purchase") {
                                let paymentType = "Credit";
                                if (model.CardType == 'Debit') {
                                    paymentType = "Debit";
                                }
                                let paymentIdByType = this.getPaymentIdByType(paymentType);
                                this.finishCardPayment(result.receipt.TransId, result.receipt.ReceiptId, false, null, paymentIdByType, result.receipt.TipAmount, creditCardType);
                            }
                            if (result.receipt.TxnName == "Refund") {
                                let model = this.props.model;
                                model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                                this.props.addRefund(this.props.posOrder.id, model);
                            }
                        } else if (parseInt(result.receipt.ResponseCode) >= 50) {
                            alert(this.props.t('pos.payment.paymentFail'));
                            console.log("the payment has completed and fail.");
                        }
                    }
                }
            }).catch((err) => {
                console.error(` Err: ${err}`);
            })
    }

    saveMonerisResponseTodb = (model) => {
        fetch(this.props.store.apiUrl + "unauthorized/monerisComplete", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        })
    }

    picCard(type, receiptId = null, amount = null) {
        let model = {};
        if (type == "P") {
            this.purchaseOrReturn = PurchaseOrReturn.Purchase;
            this.receiptId = ((this.props.posOrder.id).toString() + 'O' + Math.floor(Math.random() * 100)).substring(0, 9);
            console.log("I want to pay with pic credit Card");
            model = {
                TransType: '00',
                InvoiceNumber: this.receiptId,
                Amount: ((this.props.amount.toFixed(2)) * 100).toString().split('.')[0]
            }
            this.setState({
                loading: true,
                picType: "P"
            });
        }
        if (type == "R") {
            let isTodayOrder = isToday(this.props.posOrder.createdDate);
            this.purchaseOrReturn = PurchaseOrReturn.Return;
            model = {
                TransType: isTodayOrder ? '05' : '03',
                InvoiceNumber: receiptId,
                Amount: (parseFloat(amount).toFixed(2) * 100).toString()
            }
            this.setState({
                loading: true,
                picType: "R"
            });
        }
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);
        this.props.payByCardPIC(model);
    }

    payByPayFirma(type, cardOrderId = null, amount = null) {
        let model = {};
        this.setState({
            loading: true
        });
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);
        // in store payment for payfirma
        if (type == 'P') {
            this.purchaseOrReturn = PurchaseOrReturn.Purchase;
            let that = this;
            model = {
                amount: this.props.amount.toFixed(2),
                currency: 'CAD',
                is_card_terminal_transaction: true,
                processor_id: this.props.pinPadId,
                custom_id: `TPS${this.makeid(9)}`
            }
            return fetch(`${this.props.store.payFirmaUrl}/sale/terminal`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.store.payFirmaToken}`
                },
                body: JSON.stringify(model)
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    that.setState({
                        loading: false
                    });
                    if (data.transaction_success == true) {
                        // adjust payment method if needed, and set card type
                        let paymentType = "Credit";
                        if (data.card_type) {
                            if (data.card_type.toUpperCase() == 'DEBIT') {
                                paymentType = "Debit";
                            } else if (data.card_type.toUpperCase() == 'VISA') {
                                that.props.formInput(1, `${that.props.name}CardType`);
                            } else if (data.card_type.toUpperCase() == 'MASTERCARD') {
                                that.props.formInput(2, `${that.props.name}CardType`);
                            } else if (data.card_type.toUpperCase() == 'AMEX') {
                                that.props.formInput(3, `${that.props.name}CardType`);
                            }
                        }
                        let paymentIdByType = that.getPaymentIdByType(paymentType);
                        that.finishCardPayment(null, data.id, false, null, paymentIdByType, data.amount_tip);
                    } else if (data.transaction_success == false) {
                        that.props.showSnackbar(data.transaction_message);
                    }
                });
        } else if (type == 'R') {
            this.purchaseOrReturn = PurchaseOrReturn.Return;
            let that = this;
            //check if the payment is from online order
            if (cardOrderId.includes(this.props.t('pos.payment.payFirmaPaidOrder'))) {
                //web payment refund
                let transactionId = cardOrderId.split(this.props.t('pos.payment.payFirmaPaidOrder'))[1];
                return fetch(`${this.props.store.apiUrl}unauthorized/webmenuUISetting/${this.props.branchId}`, {
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (data) {
                        let payfirmaToken = data.data.payfirmaApiPaymentToken;
                        let payfirmaUrl = that.props.store.apiUrl == 'https://techposdev-api.azurewebsites.net/api/' || that.props.store.apiUrl == 'http://localhost:29232/api/' ? 'https://sandbox-apigateway.payfirma.com/transaction-service' : 'https://apigateway.payfirma.com/transaction-service'
                        let model = {
                            amount: amount
                        };
                        return fetch(`${payfirmaUrl}/refund/${transactionId}`, {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${payfirmaToken}`
                            },
                            body: JSON.stringify(model)
                        })
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (data) {
                                that.setState({
                                    loading: false
                                });
                                if (data.transaction_success == true) {
                                    if (data.card_type.toUpperCase() == 'VISA') {
                                        that.props.formInput(1, `${that.props.name}CardType`);
                                    } else if (data.card_type.toUpperCase() == 'MASTERCARD') {
                                        that.props.formInput(2, `${that.props.name}CardType`);
                                    } else if (data.card_type.toUpperCase() == 'AMEX') {
                                        that.props.formInput(3, `${that.props.name}CardType`);
                                    }
                                    let model = that.props.model;
                                    model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                                    that.props.addRefund(that.props.posOrder.id, model);
                                } else if (data.transaction_success == false) {
                                    that.props.showSnackbar(data.transaction_message);
                                } else if (data.message) {
                                    that.props.showSnackbar(data.message);
                                }
                            });
                    });
            } else {
                //in store payment refund
                model = {
                    amount: amount,
                    currency: 'CAD',
                    is_card_terminal_transaction: true,
                    processor_id: this.props.pinPadId
                }
                return fetch(`${this.props.store.payFirmaUrl}/refund/${cardOrderId}`, {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.props.store.payFirmaToken}`
                    },
                    body: JSON.stringify(model)
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (data) {
                        that.setState({
                            loading: false
                        });
                        if (data.transaction_success == true) {
                            if (data.card_type.toUpperCase() == 'VISA') {
                                that.props.formInput(1, `${that.props.name}CardType`);
                            } else if (data.card_type.toUpperCase() == 'MASTERCARD') {
                                that.props.formInput(2, `${that.props.name}CardType`);
                            } else if (data.card_type.toUpperCase() == 'AMEX') {
                                that.props.formInput(3, `${that.props.name}CardType`);
                            }
                            let model = that.props.model;
                            model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                            that.props.addRefund(that.props.posOrder.id, model);
                        } else if (data.transaction_success == false) {
                            that.props.showSnackbar(data.transaction_message);
                        }
                    });
            }
        }
    }

    payByPaymentree(type, cardOrderId = null, amount = null) {
        let model = {};
        this.setState({
            loading: true
        });
        let p = this.props;
        let token = getToken();
        let that = this;
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);
        let transactionId = ((that.props.posOrder.id).toString() + 'O' + Math.floor(Math.random() * 100)).substring(0, 9);
        if (type == "P") {
            that.purchaseOrReturn = PurchaseOrReturn.Purchase;
            model = {
                BranchId: p.branchId,
                Amount: parseFloat(that.props.amount),
                PinpadId: p.pinPadId,
                Type: "purchase",
                TransactionId: transactionId,
                Cashier: p.cashFlow.employee.id,
                OrderId: (p.posOrder.id).toString()
            };
        } else if (type == 'R') {
            that.purchaseOrReturn = PurchaseOrReturn.Return;
            model = {
                BranchId: p.branchId,
                Amount: parseFloat(amount),
                PinpadId: p.pinPadId,
                Type: "refund",
                TransactionId: cardOrderId,
                Cashier: p.cashFlow.employee.id,
                OrderId: (p.posOrder.id).toString()
            };
        }
        fetch(`${p.store.apiUrl}unauthorized/websocketconnection`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'timezone_offset': new Date(Date.now()).getTimezoneOffset()
            },
            body: JSON.stringify(model)
        }).then(function (response) {
            return response.json();
        }).then(function (operationResult) {
            let result = operationResult.data.data;
            that.setState({
                loading: false,
                showProductBtn: false
            });
            console.log(result);
            if (result && result.responseCode === "0") {
                let paymentType = "Credit";
                if (result.emvAppLabel) {
                    if (result.emvAppLabel.toUpperCase() == 'INTERAC') {
                        paymentType = "Debit";
                    } else if (result.emvAppLabel.toUpperCase() == 'VISA') {
                        that.props.formInput(1, `${that.props.name}CardType`);
                    } else if (result.emvAppLabel.toUpperCase() == 'MASTERCARD') {
                        that.props.formInput(2, `${that.props.name}CardType`);
                    } else if (result.emvAppLabel.toUpperCase() == 'AMEX') {
                        that.props.formInput(3, `${that.props.name}CardType`);
                    }
                }
                if (type == "P") {
                    let paymentIdByType = that.getPaymentIdByType(paymentType);
                    that.finishCardPayment(null, result.transId, false, null, paymentIdByType, null);
                } else if (type == 'R') {
                    let model = that.props.model;
                    model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                    that.props.addRefund(that.props.posOrder.id, model);
                }
            } else if (result && result.responseCode !== "0") {
                that.props.showSnackbar(result.hostResponseMessage);
            } else {
                that.props.showSnackbar(this.props.t('pos.payment.operationFail'));
            }
        });
    }

    payByPaystone(type, receiptId = null, amount = null) {
        this.setState({
            loading: true
        });
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);

        if (type == 'P') {
            this.purchaseOrReturn = PurchaseOrReturn.Purchase;
            let that = this;
            let model = {
                "method": "startPaymentTransaction",
                "requestId": new Date().getTime(),
                "targetType": "paymentGatewayConverge",
                "version": "1.0",
                "parameters": {
                    "paymentGatewayId": localStorage.getItem('TECHPOS_PAYSTONE_GATEWAY_ID'),
                    "transactionType": "SALE",
                    "partialApprovalAllowed": true,
                    "baseTransactionAmount": {
                        "value": parseInt(that.props.amount.toFixed(2) * 100),
                        "currencyCode": "CAD"
                    },
                    "tenderType": "CARD",
                    "discountAmounts": null,
                    "invoiceNumber": (that.props.posOrder.id).toString()
                }
            };
            //console.log("request model", model);
            return fetch(`https://localhost:9790/rest/command`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model),
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                //console.log(data);
                that.getPaystoneResponseInterval = setInterval(() => {
                    that.checkPaystonePaymentResult('P', data.data.paymentGatewayCommand.chanId);
                }, 1000)
            });
        } else if (type == 'R') {
            this.purchaseOrReturn = PurchaseOrReturn.Return;
            let that = this;
            let model = {
                "method": "linkedRefund",
                "requestId": new Date().getTime(),
                "targetType": "paymentGatewayConverge",
                "version": "1.0",
                "parameters": {
                    "baseTransactionAmount": {
                        "value": parseInt(amount * 100),
                        "currencyCode": "CAD"
                    },
                    "paymentGatewayId": localStorage.getItem('TECHPOS_PAYSTONE_GATEWAY_ID'),
                    "originalTransId": receiptId,
                    "tenderType": "CARD",
                    "cardType": that.props.returnMethod == OrderProductStatus.ReturnedDebitCard ? "DEBIT" : "CREDIT"
                }
            };
            //console.log("request model", model);
            return fetch(`https://localhost:9790/rest/command`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model),
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                //console.log(data);
                that.getPaystoneResponseInterval = setInterval(() => {
                    that.checkPaystonePaymentResult('R', data.data.paymentGatewayCommand.chanId);
                }, 1000)
            });
        }
    }

    checkPaystonePaymentResult(type, chanId) {
        let model = {
            "method": "getPaymentTransactionStatus",
            "requestId": new Date().getTime(),
            "targetType": "paymentGatewayConverge",
            "version": "1.0",
            "parameters": {
                "paymentGatewayId": localStorage.getItem('TECHPOS_PAYSTONE_GATEWAY_ID'),
                "chanId": chanId
            }
        };
        let that = this;
        return fetch(`https://localhost:9790/rest/command`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            console.log(data.data);
            if (data.data.paymentGatewayCommand.completed && data.data.paymentGatewayCommand.paymentTransactionData && (data.data.paymentGatewayCommand.paymentTransactionData.result == "APPROVED" || data.data.paymentGatewayCommand.paymentTransactionData.result == "PARTIALLY_APPROVED")) {
                that.setState({
                    loading: false
                });
                clearInterval(that.getPaystoneResponseInterval);
                let transationData = data.data.paymentGatewayCommand.paymentTransactionData;
                //print receipts
                let model = {
                    ...transationData,
                    paystoneInStoreDBA: "Retail TechPOS",
                    paystoneInStoreTID: "TechPOS",
                    paystoneInStoreUserId: "TechPOS",
                };
                that.props.printPaystoneInStoreReceipt(model);
                if (transationData.result == "APPROVED") {
                    if (type == 'P') {
                        that.finishCardPayment(null, data.data.paymentGatewayCommand.paymentTransactionData.id, false, that.props.amount.toFixed(2), null);
                    } else if (type == 'R') {
                        let refundModel = that.props.model;
                        refundModel.OrderProductsVM = refundModel.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                        that.props.addRefund(that.props.posOrder.id, refundModel);
                    }
                } else if (transationData.result == "PARTIALLY_APPROVED") {
                    that.finishCardPayment(null, data.data.paymentGatewayCommand.paymentTransactionData.id, false, (transationData.amountAuthorized.value) / 100, null);
                }

            } else if (data.data.paymentGatewayCommand.completed && data.data.paymentGatewayCommand.paymentTransactionData && (data.data.paymentGatewayCommand.paymentTransactionData.result == "DECLINED" || data.data.paymentGatewayCommand.paymentTransactionData.result == "FAILED")) {
                that.setState({
                    loading: false
                });
                clearInterval(that.getPaystoneResponseInterval);
                if (type == 'P') {
                    alert(this.props.t('pos.payment.paymentFailedWarning'));
                } else if (type == 'R') {
                    alert(this.props.t('pos.payment.refundFailedWarning'));
                }
                return;
            }
        });
    }

    payByPICPoynt(type, cardOrderId = null, amount = null) {
        this.setState({
            loading: true
        });
        let p = this.props;
        let token = getToken();
        let that = this;
        fetch(`${p.store.apiUrl}unauthorized/picPoyntData/${p.branchId}`, {
            method: "GET",
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'timezone_offset': new Date(Date.now()).getTimezoneOffset()
            }
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            let activationKey = data.data.activationKey;
            let invoice_no = ((that.props.posOrder.id).toString() + 'O' + Math.floor(Math.random() * 100)).substring(0, 9);
            setTimeout(() => {
                that.setState({ showProductBtn: true });
            }, problemBtnShowTime);
            let model = {
                activation_key: activationKey
            };
            fetch(`https://cpospic.com/api/getaccesstoken.php`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            }).then(function (response) {
                return response.json();
            }).then(function (token) {
                let access_token = token.access_token;
                let model = {};
                if (type == "P") {
                    that.purchaseOrReturn = PurchaseOrReturn.Purchase;
                    model = {
                        transaction_type: "00",
                        total_amount: parseFloat(that.props.amount) * 100,
                        invoice_no: invoice_no,
                        api_token: data.data.apiToken,
                        response_type: "json",
                        terminal_transaction_id: ""
                    };
                } else if (type == 'R') {
                    that.purchaseOrReturn = PurchaseOrReturn.Return;
                    model = {
                        transaction_type: "03",
                        total_amount: parseFloat(amount) * 100,
                        invoice_no: invoice_no,
                        api_token: data.data.apiToken,
                        response_type: "json",
                        terminal_transaction_id: cardOrderId
                    };
                }

                fetch(`https://cpospic.com/api/pushorder.php`, {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Apikey': access_token
                    },
                    body: JSON.stringify(model)
                }).then(function (response) {
                    return response.json();
                }).then(function (operationResult) {
                    let result = operationResult;
                    that.setState({
                        loading: false,
                        showProductBtn: false
                    });
                    if (result && result.TransactionStatus == "Approved") {
                        let paymentType = "Credit";
                        if (result.CustomerCardType) {
                            if (result.CustomerCardType.toUpperCase() == 'INTERAC') {
                                paymentType = "Debit";
                            } else if (result.CustomerCardType.toUpperCase() == 'VISA') {
                                that.props.formInput(1, `${that.props.name}CardType`);
                            } else if (result.CustomerCardType.toUpperCase() == 'MASTERCARD') {
                                that.props.formInput(2, `${that.props.name}CardType`);
                            } else if (result.CustomerCardType.toUpperCase() == 'AMEX') {
                                that.props.formInput(3, `${that.props.name}CardType`);
                            }
                        }
                        if (type == "P") {
                            let paymentIdByType = that.getPaymentIdByType(paymentType);
                            that.finishCardPayment(null, result.TransactionId, false, null, paymentIdByType, null);
                        } else if (type == 'R') {
                            let model = that.props.model;
                            model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                            that.props.addRefund(that.props.posOrder.id, model);
                        }
                    } else if (result && result.TransactionStatus != "Approved") {
                        that.props.showSnackbar(result.TransactionStatus);
                    } else {
                        that.props.showSnackbar(this.props.t('pos.payment.operationFail'));
                    }
                });
            });
        });
    }

    payByGlobal(type, receiptId = null, amount = null) {
        let model = {};
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);
        if (type == "P") {
            this.purchaseOrReturn = PurchaseOrReturn.Purchase;
            model = {
                Type: 'Sale',
                ECRId: this.props.cashFlow.id,
                RequestId: ((this.props.posOrder.id).toString() + Math.floor(Math.random() * 100)).substring(0, 9),
                BaseAmount: this.props.amount.toFixed(2),
                IPAddress: this.props.ipAddress
            }
            this.setState({
                loading: true,
                globalType: "P"
            });
        }
        if (type == "R") {
            this.purchaseOrReturn = PurchaseOrReturn.Return;
            model = {
                Type: 'Refund',
                ECRId: this.props.cashFlow.id,
                RequestId: ((this.props.posOrder.id).toString() + Math.floor(Math.random() * 100)).substring(0, 9),
                BaseAmount: amount,
                IPAddress: this.props.ipAddress,
                ReferenceNumber: receiptId
            }
            this.setState({
                loading: true,
                globalType: "R"
            });
        }

        this.props.payByGlobal(model);
    }

    payByAdyen(type, receiptId = null, cardTxnNumber = null, amount = null) {
        this.setState({
            loading: true
        });
        setTimeout(() => {
            this.setState({ showProductBtn: true });
        }, problemBtnShowTime);
        let model = {};
        console.log("Adyen payment");
        if (type == "P") {
            model = {
                Amount: this.props.amount.toFixed(2),
                DeviceId: this.props.pinPadId,
                OrderPaymentId: ((this.props.posOrder.id).toString() + Math.floor(Math.random() * 100)).substring(0, 9),
                AdyenApiKey: this.props.adyenInStorePaymentAPIKey,
                Country: this.props.store.country,
            }
            this.props.adyenPaymentRequest(model);
        }
        if (type == "R") {
            model = {
                AmountValue: amount,
                DeviceId: this.props.pinPadId,
                SaleTransactionId: receiptId,
                SaleTimeStamp: cardTxnNumber,
                AdyenApiKey: this.props.adyenInStorePaymentAPIKey,
                Country: this.props.store.country
            }
            this.props.adyenRefundRequest(model);
        }
    }

    payByGiftCard() {
        let model = this.props.giftCardModel;
        model.OrderId = this.props.store.monerisStoreId + this.props.posOrder.id.toString() + "r" + Math.floor(Math.random() * 100);
        model.POSOrderId = this.props.posOrder.id;
        model.OrderModifiedDate = this.props.posOrder.modifiedDate;
        console.log(model);
        this.props.giftCardPurchase(model);
    }

    payByPaystoneGiftCard() {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            CardNumber: p.paystoneCardNumber,
            PayStoneOperations: LOOKUP.PayStoneGiftCardOperationType.Redeem,
            WAN: p.cashFlow.employee.id,
            WSN: p.cashFlow.deviceId,
            Amount: p.amount,
            InvoiceNumber: `${p.branchId}_${LOOKUP.PayStoneGiftCardOperationType.Redeem}_${this.props.posOrder.id.toString()}_r_${Math.floor(Math.random() * 100)}`,
            OrderId: p.posOrder.id,
            OrderModifiedDate: p.posOrder.modifiedDate
        };
        this.props.paystoneGiftCardPurchase(model);
    }

    payByBirchmountGiftCard() {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            Operations: LOOKUP.PayStoneGiftCardOperationType.Redeem,
            CardNumber: p.birchmountGiftCardNumber,
            PIN: p.birchmountGiftCardPIN,
            Amount: p.amount,
            OrderTotal: (p.posOrder.total).toString(),
            OrderId: p.posOrder.id,
            OrderModifiedDate: p.posOrder.modifiedDate
        };
        this.props.birchmountGiftCardPurchase(model);
    }

    displayGiftCardError = () => {
        this.setState({ giftCardProcessError: true }, () => {
            setTimeout(() => {
                this.setState({ giftCardProcessError: false });
            }, 3000);
        });
    }

    handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        let formattedValue = "";
        for (let i = 0; i < value.length; i++) {
            if (i > 0 && i % 4 === 0) {
                formattedValue += " ";
            }
            formattedValue += value[i];
        }

        this.setState({ formattedCardNumber: formattedValue });
        this.props.formInput(value, "POSGiftCardCardNumber")
    }

    applyAmountToGiftCard = () => {
        const { giftCardNumber, giftCardPaymentAmount } = this.props
        if (!giftCardNumber || !giftCardPaymentAmount || giftCardPaymentAmount === "0.00") {
            this.props.showSnackbar(this.props.t('pos.payment.cardEnterErrorMsg'))
            return
        }
        const model = {
            BranchId: this.props.branchId,
            CardNumber: giftCardNumber,
            PurchaseAmount: giftCardPaymentAmount,
            OrderId: this.props.posOrder.id,
            OrderModifiedDate: this.props.posOrder.modifiedDate
        }
        this.props.chargeGiftCard(model)
    }

    checkOrderUpdateTime = () => {
        if (this.props.noSalesAllowedAfterStoreHours && ((new Date().getHours()) >= this.props.storeCloseHour || (new Date().getHours()) < this.props.storeOpenHour)) {
            this.props.showError(this.props.t('pos.messages.orderAfterStoreHours'));
            return;
        } else {
            if (this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") {
                this.props.checkOrderUpdateTime(this.props.posOrder.id, this.props.posOrder.modifiedDate)
            } else {
                this.confirmPayment();
            }
        }
    }

    confirmPayment = (cardTxnNumber = null, cardOrderId = null) => {
        if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.monerisEnabled && this.props.pinPadIntegrated) {
            this.getReceiptUrl("P").then(r => this.checkUrlInterval(r));
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.picEnabled && this.props.pinPadIntegrated) {
            this.props.formInput(null, 'picStatus');
            this.props.formInput(null, 'abortPICTimeStamp');
            this.picCard("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.payFirmaEnabled && this.props.pinPadIntegrated) {
            this.payByPayFirma("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.paymentreeInStoreEnabled && this.props.pinPadIntegrated) {
            this.payByPaymentree("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.picPoyntInStoreEnabled && this.props.pinPadIntegrated) {
            this.payByPICPoynt("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.paystoneInStoreEnabled && this.props.pinPadIntegrated) {
            this.payByPaystone("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.globalInStorePaymentEnabled && this.props.pinPadIntegrated) {
            this.payByGlobal("P");
        } else if ((this.state.selectedPaymentMethod.name == "Credit" || this.state.selectedPaymentMethod.name == "Debit") && this.props.store.adyenInStorePaymentEnabled && this.props.pinPadIntegrated) {
            this.payByAdyen("P");
        } else if (this.state.selectedPaymentMethod.name == "GiftCard" && this.props.genericGiftCardEnabled) {
            this.applyAmountToGiftCard()
        } else if (this.state.selectedPaymentMethod.name == "GiftCard" && this.props.store.monerisGiftCardEnabled && this.props.pinPadIntegrated) {
            this.payByGiftCard();
        } else if (this.state.selectedPaymentMethod.name == "GiftCard" && this.props.paystoneGiftCardEnabled) {
            this.payByPaystoneGiftCard();
        } else if (this.state.selectedPaymentMethod.name == "GiftCard" && this.props.birchmountGiftCardEnabled) {
            this.payByBirchmountGiftCard();
        } else if (this.state.selectedPaymentMethod.name == "Online") {
            const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
            const model = {
                amount: parseFloat(this.props.amount),
                receiptNumber: this.props.receiptNumber,
                storeCreditCode: this.props.storeCreditCode,
                orderId: this.props.posOrder.id,
                deviceId: deviceData.id,
                paymentId: this.state.selectedPaymentMethod.id,
                employeeId: this.props.userPin.employee.id,
                branchId: this.props.branchId,
                cardTxnNumber: cardTxnNumber,
                cardOrderId: "PaidOnline",
                cardType: this.props.posPaymentscardType,
                modifiedDate: this.props.posOrder.modifiedDate
            };
            this.props.addPaymentToOrder(model);
            this.onPaymentSelect(null);
        }
        else if (this.props.posOrder && this.state.selectedPaymentMethod) {
            const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
            const model = {
                amount: parseFloat(this.props.amount),
                receiptNumber: this.props.receiptNumber,
                storeCreditCode: this.props.storeCreditCode,
                orderId: this.props.posOrder.id,
                deviceId: deviceData.id,
                paymentId: this.state.selectedPaymentMethod.id,
                employeeId: this.props.userPin.employee.id,
                branchId: this.props.branchId,
                cardTxnNumber: cardTxnNumber,
                cardOrderId: cardOrderId,
                cardType: this.props.posPaymentscardType,
                modifiedDate: this.props.posOrder.modifiedDate
            };

            const requireStoreCreditCode = this.state.selectedPaymentMethod.name !== "Cash" && this.state.selectedPaymentMethod.name !== "Debit" && this.state.selectedPaymentMethod.name !== "Credit" && this.state.selectedPaymentMethod.name !== "GiftCard";
            const validators = [
                [this.props.name + 'StoreCreditCode', model => (!requireStoreCreditCode || (model.storeCreditCode && model.storeCreditCode !== null && model.storeCreditCode !== "")), "Store Credit Code"],
                [this.props.name + 'Amount', model => (model.amount !== "" && model.amount !== 0), "Amount"]
            ];

            if (util.validate(validators, model, this.props.formError)) {
                this.props.addPaymentToOrder(model);
                this.onPaymentSelect(null);
            }
        }
    }

    finishCardPayment = (cardTxnNumber = null, cardOrderId = null, manualApproval = false, paymentAmount = null, newPaymentId = null, tipAmount = null, autoCardType = 0) => {
        if (this.props.posOrder && this.state.selectedPaymentMethod) {
            const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
            let amount = parseFloat(this.props.amount);
            if (paymentAmount !== null) {
                amount = parseFloat(paymentAmount);
            }

            let paymentId = this.state.selectedPaymentMethod.id;
            if (newPaymentId !== null && newPaymentId > 0) {
                paymentId = newPaymentId;
            }

            const model = {
                amount: amount,
                receiptNumber: this.props.receiptNumber,
                storeCreditCode: this.props.storeCreditCode,
                orderId: this.props.posOrder.id,
                deviceId: deviceData.id,
                paymentId: paymentId,
                employeeId: this.props.userPin.employee.id,
                branchId: this.props.branchId,
                cardTxnNumber: cardTxnNumber,
                cardOrderId: cardOrderId,
                cardType: autoCardType || this.props.posPaymentscardType,
                manualApproval: manualApproval,
                manualApprovalUserId: manualApproval ? this.props.managerApprovalUserId : "",
                tipAmount: tipAmount,
                modifiedDate: this.props.posOrder.modifiedDate
            };

            const requireStoreCreditCode = this.state.selectedPaymentMethod.name !== "Cash" && this.state.selectedPaymentMethod.name !== "Debit" && this.state.selectedPaymentMethod.name !== "Credit" && this.state.selectedPaymentMethod.name !== "GiftCard";
            const validators = [
                [this.props.name + 'StoreCreditCode', model => (!requireStoreCreditCode || (model.storeCreditCode && model.storeCreditCode !== null && model.storeCreditCode !== "")), "Store Credit Code"],
                [this.props.name + 'Amount', model => (model.amount !== "" && model.amount !== 0), "Amount"]
            ];

            if (util.validate(validators, model, this.props.formError)) {
                this.props.addPaymentToOrder(model);
                this.onPaymentSelect(null);
            }
        }
    }

    cardRefund = (cardOrderId, cardTxnNumber, amount) => {
        this.getReceiptUrl("R", cardOrderId, cardTxnNumber, amount).then(r => this.checkUrlInterval(r));
    }

    picRefund = (receiptId, amount) => {
        console.log(receiptId);
        console.log(amount);
        this.picCard("R", receiptId, amount);
    }

    payFirmaRefund = (cardOrderId, amount) => {
        if (cardOrderId) {
            this.payByPayFirma('R', cardOrderId, amount);
        } else {
            this.setState({ payfirmaRefundDialog: true });
        }
    }

    paymentreeRefund = (cardOrderId, amount) => {
        this.payByPaymentree('R', cardOrderId, amount);
    }

    picPoyntRefund = (cardOrderId, amount) => {
        this.payByPICPoynt('R', cardOrderId, amount);
    }

    paystoneRefund = (cardOrderId, amount) => {
        this.payByPaystone('R', cardOrderId, amount);
    }

    globalRefund = (cardOrderId, amount) => {
        this.payByGlobal('R', cardOrderId, amount);
    }

    adyenRefund = (cardOrderId, cardTxnNumber, amount) => {
        this.payByAdyen('R', cardOrderId, cardTxnNumber, amount);
    }

    addShippingCost = () => {
        this.props.addShippingCost(this.props.posOrder.id, this.props.shippingCost, this.props.posOrder.modifiedDate);
        this.closeAddShippingCostDialog();
    }

    addTipAmount = () => {
        this.props.addTipAmount(this.props.posOrder.id, this.props.tipAmount, this.props.posOrder.modifiedDate);
        this.closeAddTipAmountDialog();
    }

    cardDeclined = () => {
        console.log("card is declined");
        this.setState({ posCardPaymentStatusDialog: false });
    }

    cardApproved = () => {
        console.log("card is approved");
        this.setState({ posCardPaymentStatusDialog: false });
        if (this.purchaseOrReturn == PurchaseOrReturn.Purchase) {
            this.finishCardPayment(null, null, true);
        } else if (this.purchaseOrReturn == PurchaseOrReturn.Return) {
            let model = this.props.model;
            model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
            this.props.addRefund(this.props.posOrder.id, model);
        }
    }

    pinpadPaymentManagerApproval = () => {
        let validators = [];

        if (!this.props.pinpadPaymentApprovalPinCode) {
            validators = [
                ["PinpadPaymentApprovalUsername", d => (d.UserName && d.UserName !== ""), "Username"],
                ["PinpadPaymentApprovalPassword", d => (d.Password && d.Password !== ""), "Password"]
            ];
        }

        let model = {
            UserName: this.props.pinpadPaymentApprovalUsername,
            Password: this.props.pinpadPaymentApprovalPassword,
            PinCode: this.props.pinpadPaymentApprovalPinCode,
            ApprovalType: "PinPadPayment"
        };

        if (util.validate(validators, model, this.props.formError)) {
            // this can be replaced to verifyCredential
            this.props.getManagerApproval(model);
            this.setState({ posCardPaymentStatusDialog: false });
        }
    }

    showPOSCardPaymentStatusDialog = () => {
        this.setState({ loading: false, posCardPaymentStatusDialog: true, showProductBtn: false });

        //remove moneris timer
        if (this.getMonerisInterval) {
            clearInterval(this.getMonerisInterval);
        }

        if (this.getPaystoneResponseInterval) {
            clearInterval(this.getPaystoneResponseInterval);
        }
    }

    sendToFulfillment = () => {
        console.log("i want to send to fulfillment");
        const orderModel = this.selectOrderModel();
        this.props.sendOrderToFulFillment(orderModel);
    }

    showStopLoading = () => {
        this.setState({ showProductBtn: true })
    }

    selectOrderModel = () => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const posOrderModel = this.props.posOrder;
        const productsModel = posOrderModel ? posOrderModel.products || [] : [];
        const branchId = this.props.branchId;
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;

        let products = productsModel ? productsModel.map((item) => {
            return {
                id: item.id,
                productId: item.productId,
                quantity: item.quantity,
                branchId: branchId,
                packageReference: item.packageReference
            };
        }) : [];

        const order = {
            id: posOrderModel ? posOrderModel.id : 0,
            patientId: posOrderModel ? posOrderModel.patientId : 0,
            deviceId: deviceData.id,
            employeeId: employeeId,
            products: products,
            branchId: branchId
        };

        return order;
    }

    makeid = (length) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        const order = p.posOrder;
        const orderIsCompleted = order && (order.status === 'Completed' || order.status === 'Returned' || order.status === 'ReturnedPartial' || order.status === 'WaitingPickUp' || order.status === 'WaitingFulfillment')
        const selectedPaymentMethod = this.state.selectedPaymentMethod;
        const doesOrderExist = this.props.posOrder ? true : false;
        const disableAllButtons = this.props.disableAllButtons;
        const validProductsFromOrder = p.posOrder ? p.posOrder.products.filter(item => item.status === OrderProductStatus.Open) : [];
        const validProductsForRefund = p.posOrder ? p.posOrder.products.filter(item => item.status === OrderProductStatus.Completed && item.qtyAvaibleForRefund > 0) : [];
        const disableRefundButton = p.posOrder ? (p.posOrder.products.filter(item => item.isRefundable && item.status === 2).length === 0) : true;
        const orderHasPayment = doesOrderExist && p.posOrder.payments && p.posOrder.payments.length > 0;
        const dynamicChangeDue = order ? Math.round((this.props.amount - order.balanceDue) * 20) / 20 : 0;
        const cardTypeOptions = [
            {
                text: t('pos.payment.visa'),
                value: "1"
            },
            {
                text: t('pos.payment.masterCard'),
                value: "2"
            },
            {
                text: t('pos.payment.amex'),
                value: "3"
            }
        ];

        const btnPaymentOptions = [
            { text: t("constants.debit"), value: "Debit" },
            { text: t("constants.credit"), value: "Credit" },
            { text: t("pos.refundDialog.cash"), value: "Cash" },
            { text: t("pos.page.storeCredit"), value: "StoreCredit" },
            { text: t("common.giftCard"), value: "GiftCard" },
            { text: t("constants.online"), value: "Online" }
        ];
        
        return (
            <React.Fragment>
                <Dialog
                    modal={true}
                    open={this.state.loading}
                    sx={{ ...loadDialogcustomContentStyle, ...loadDialogStyle }}>

                    <DialogContent>
                        <div className="loading" onClick={this.showStopLoading}>
                            <CircularProgress size={50} thickness={5} />
                            <br />
                            <h4 className="text-center">{t('pos.payment.loading')}</h4>
                            {this.state.showProductBtn ?
                                <div className="pospaymentLoadingProblemBtn"
                                    onClick={() => this.showPOSCardPaymentStatusDialog()}
                                >
                                    {t('pos.payment.notWorkingQuestion')}
                                </div>
                                : ''
                            }
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    style={loadDialogStyle}
                    open={this.state.payfirmaRefundDialog}>
                    <CustomButton
                        name="close"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.closePayfirmaRefundDialog()} />
                    <p className="pa-2 text-center">
                        {t('pos.payment.cantFindTransactionId')}<br />
                        {t('pos.payment.stillNeedToRefundWarning')}
                    </p>
                    <CustomButton
                        key={1}
                        label={t('common.cancel')}
                        className="bg-red"
                        primary={true}
                        onTouchTap={() => this.closePayfirmaRefundDialog()}
                    />
                    <CustomButton
                        key={3}
                        label={t('common.confirm')}
                        className="pull-right bg-light-green"
                        primary={true}
                        onTouchTap={() => this.confirmPayfirmaRefund()}
                    />
                </Dialog>

                <POSCardPaymentStatusDialog
                    name="posCardPaymentStatusDialog"
                    open={this.state.posCardPaymentStatusDialog}
                    onClose={() => this.closePOSCardPaymentStatusDialog()}
                    declined={() => this.cardDeclined()}
                    approved={() => this.cardApproved()}
                    managerApproval={this.pinpadPaymentManagerApproval}
                />

                <POSDiscountDialog
                    name="posDialogDiscount"
                    open={this.state.dialogDiscount}
                    onClose={() => this.closeDiscountDialog()}
                    orderId={p.posOrder ? p.posOrder.id : 0}
                    orderTotal={p.posOrder ? p.posOrder.subTotal : 0}
                />

                <POSRemoveDiscountDialog
                    name="posDialogRemoveDiscount"
                    open={this.state.dialogRemoveDiscount}
                    onClose={() => this.closeRemoveDiscountDialog()}
                    orderId={p.posOrder ? p.posOrder.id : 0}
                />

                <POSRefundDialog
                    name="posDialogRefund"
                    open={this.state.dialogRefund}
                    onClose={() => this.closeRefundDialog()}
                    orderId={p.posOrder ? p.posOrder.id : 0}
                    cardRefund={(cardOrderId, cardTxnNumber, amount) => this.cardRefund(cardOrderId, cardTxnNumber, amount)}
                    picRefund={(cardOrderId, refundAmount) => this.picRefund(cardOrderId, refundAmount)}
                    payFirmaRefund={(cardOrderId, refundAmount) => this.payFirmaRefund(cardOrderId, refundAmount)}
                    paymentreeRefund={(cardOrderId, refundAmount) => this.paymentreeRefund(cardOrderId, refundAmount)}
                    picPoyntRefund={(cardOrderId, refundAmount) => this.picPoyntRefund(cardOrderId, refundAmount)}
                    printPaystoneGiftCardReceipt={this.props.printPaystoneGiftCardReceipt}
                    printBirchmountGiftCardReceipt={this.props.printBirchmountGiftCardReceipt}
                    paystoneRefund={(cardOrderId, refundAmount) => this.paystoneRefund(cardOrderId, refundAmount)}
                    globalRefund={(cardOrderId, refundAmount) => this.globalRefund(cardOrderId, refundAmount)}
                    adyenRefund={(cardOrderId, cardTxnNumber, refundAmount) => this.adyenRefund(cardOrderId, cardTxnNumber, refundAmount)} />

                <POSAddShippingCostDialog
                    name="posDialogAddShippingCost"
                    open={this.state.dialogAddShippingCost}
                    onClose={() => this.closeAddShippingCostDialog()}
                    addShippingCost={() => this.addShippingCost()}
                    orderId={this.props.posOrder ? this.props.posOrder.id : null}
                />

                <POSAddTipAmountDialog
                    name="posDialogAddTipAmount"
                    open={this.state.dialogAddTipAmount}
                    onClose={() => this.closeAddTipAmountDialog()}
                    addTipAmount={() => this.addTipAmount()}
                    orderId={this.props.posOrder ? this.props.posOrder.id : null}
                />

                {
                    selectedPaymentMethod ? (
                        <div className="p-0">
                            <h4 className="purpleText">{selectedPaymentMethod.name}:</h4>
                            {
                                selectedPaymentMethod ?
                                    (() => {
                                        switch (selectedPaymentMethod.name) {
                                            // debit, credit
                                            case "Credit":
                                                return (
                                                    !this.props.store.monerisEnabled && !this.props.store.picEnabled && !this.props.store.payFirmaEnabled && !this.props.store.paystoneInStoreEnabled && !this.props.store.picPoyntInStoreEnabled && !this.props.store.paymentreeInStoreEnabled && !this.props.store.globalInStorePaymentEnabled && !this.props.store.adyenInStorePaymentEnabled ?
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <TextInput name={`${p.name}ReceiptNumber`}
                                                                    autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'Debit' ? true : false}
                                                                    fullWidth={true}
                                                                    label={t('pos.payment.receiptNumber')}
                                                                    floatingLabelText={t('pos.payment.receiptNumber')}
                                                                    hintText={t('pos.payment.receiptNumber')}
                                                                    maxLength="30"
                                                                />
                                                            </div>
                                                        </div>
                                                        : null
                                                );
                                            case "Debit":
                                                return (
                                                    !this.props.store.monerisEnabled && !this.props.store.picEnabled && !this.props.store.payFirmaEnabled && !this.props.store.paystoneInStoreEnabled && !this.props.store.picPoyntInStoreEnabled && !this.props.store.paymentreeInStoreEnabled && !this.props.store.globalInStorePaymentEnabled && !this.props.store.adyenInStorePaymentEnabled ?
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <TextInput name={`${p.name}ReceiptNumber`}
                                                                    autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'Debit' ? true : false}
                                                                    fullWidth={true}
                                                                    label={t('pos.payment.receiptNumber')}
                                                                    floatingLabelText={t('pos.payment.receiptNumber')}
                                                                    hintText={t('pos.payment.receiptNumber')}
                                                                    maxLength="30"
                                                                />
                                                            </div>
                                                        </div> : null
                                                );
                                            // cash
                                            case "Cash":
                                                return (
                                                    <React.Fragment>
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <h6 className="purpleText">{t('pos.payment.bills')}</h6>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(5)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 5</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(10)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 10</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(20)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 20</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(50)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 50</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(100)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 100</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount("exactCash")} id="exactCashBtn" className="btn pull-left btn-block btn-grid-small-auto sale-cash-btn">{t('pos.payment.exactCash')}</CustomButton>
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <label className="purpleText">{t('pos.payment.coins')}</label>
                                                                <br />
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(0.05)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 0.05</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(0.10)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 0.10</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(0.25)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 0.25</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(1.00)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 1.00</CustomButton>
                                                                <CustomButton type="button" onTouchTap={() => this.addToAmount(2.00)} className="btn pull-left btn-block btn-grid-small sale-cash-btn mr-1">$ 2.00</CustomButton>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                );
                                            case "StoreCredit":
                                                return (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <TextInput name={`${p.name}StoreCreditCode`}
                                                                autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'StoreCredit' ? true : false}
                                                                fullWidth={true}
                                                                label={t('pos.payment.storeCreditCode')}
                                                                floatingLabelText={t('pos.payment.storeCreditCode')}
                                                                hintText={t('pos.payment.storeCreditCode')}
                                                                maxLength="10" />
                                                        </div>
                                                    </div>
                                                );
                                            case "GiftCard":
                                                return (
                                                    <React.Fragment>
                                                        {
                                                            this.props.monerisGiftCardEnabled ?
                                                                (
                                                                    <div className="row">
                                                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                                            <ToggleInput className="giftCard_process_method" name={`${p.name}processMethod`} label={t('pos.payment.processMethod')} />
                                                                        </div>
                                                                        {this.state.giftCardProcessError ? (
                                                                            <h5 style={{ color: 'red', animation: 'slideInOut 3s', fontSize: '20px', fontWeight: 'bold' }}>
                                                                                {this.props.giftCardPurchaseFailResponse}
                                                                            </h5>
                                                                        ) : null}
                                                                        {
                                                                            this.props.proceddMethod ?
                                                                                (
                                                                                    <div className="p-0">
                                                                                        <div className="col-lg-12">
                                                                                            <TextInput name={`${p.name}GiftCardNumber`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.cardNum')}
                                                                                                floatingLabelText={t('pos.payment.cardNum')}
                                                                                                hintText={t('pos.payment.cardNum')}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-12">
                                                                                            <TextInput name={`${p.name}GiftCardExpireDate`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.expdate')}
                                                                                                floatingLabelText={t('pos.payment.expdate')}
                                                                                                hintText={t('pos.payment.expdate')}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-12">
                                                                                            <TextInput name={`${p.name}GiftCardCvdValue`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.cvCode')}
                                                                                                floatingLabelText={t('pos.payment.cvCode')}
                                                                                                hintText={t('pos.payment.cvCode')}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                                :
                                                                                (
                                                                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                                                        <div className="col-lg-12">
                                                                                            <h5>{t('pos.giftCard.readyToSwipeCard.text')}</h5>
                                                                                            <TextInput name={`${p.name}GiftCardCvdValue`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.cvCode')}
                                                                                                floatingLabelText={t('pos.payment.cvCode')}
                                                                                                hintText={t('pos.payment.cvCode')}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                )
                                                                :
                                                                (
                                                                    this.props.paystoneGiftCardEnabled ?
                                                                        (
                                                                            <div>
                                                                                <div className="col-lg-12">
                                                                                    <TextInput name={`${p.name}PaystoneGiftCardNumber`}
                                                                                        fullWidth={true}
                                                                                        label={t('pos.payment.cardNum')}
                                                                                        floatingLabelText={t('pos.payment.cardNum')}
                                                                                        hintText={t('pos.payment.cardNum')}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                        :
                                                                        (
                                                                            this.props.birchmountGiftCardEnabled ?
                                                                                (
                                                                                    <div className="row">
                                                                                        <div className="col-lg-12">
                                                                                            <TextInput name={`${p.name}BirchmountGiftCardNumber`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.cardNum')}
                                                                                                floatingLabelText={t('pos.payment.cardNum')}
                                                                                                hintText={t('pos.payment.cardNum')}
                                                                                                maxLength="30"
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-12">
                                                                                            <TextInput name={`${p.name}BirchmountGiftCardPIN`}
                                                                                                fullWidth={true}
                                                                                                label={t('pos.payment.pin')}
                                                                                                floatingLabelText={t('pos.payment.pin')}
                                                                                                hintText={t('pos.payment.pin')}
                                                                                                maxLength="30"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                                :
                                                                                (
                                                                                    this.props.genericGiftCardEnabled ?
                                                                                        (
                                                                                            <div className="row">
                                                                                                <div className="col-lg-12">
                                                                                                    {this.state.giftCardProcessError ? (
                                                                                                        <h5 style={{ color: 'red', animation: 'slideInOut 3s', fontSize: '20px', fontWeight: 'bold' }}>
                                                                                                            {this.props.giftCardPurchaseFailResponse}
                                                                                                        </h5>
                                                                                                    ) : null}
                                                                                                    <Paper style={{
                                                                                                        padding: '20px',
                                                                                                        marginBottom: '20px',
                                                                                                        marginTop: '20px',
                                                                                                        borderRadius: '15px',
                                                                                                        background: 'linear-gradient(45deg, #a697e2 30%, #8a73ea 90%)',
                                                                                                        boxShadow: '0 3px 5px 2px rgba(198, 186, 246, .3)'
                                                                                                    }}>
                                                                                                        <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                                                                                                            <h2 style={{ width: '75%' }}>{t('common.giftCard')}</h2>
                                                                                                            <h2 style={{ width: '20%', textAlign: 'left', color: "white" }}>{t('pos.payment.amountToReceive')}</h2>
                                                                                                        </div>
                                                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                                                                                                            <div style={{ width: '75%' }}>
                                                                                                                <TextField
                                                                                                                    className="POSGiftCard-input"
                                                                                                                    name={`POSGiftCardPurchaseCardNumber`}
                                                                                                                    fullWidth={true}
                                                                                                                    type="text"
                                                                                                                    floatingLabelText={t('pos.payment.giftCardNum')}
                                                                                                                    hintText={t('pos.payment.enterCardNum')}
                                                                                                                    floatingLabelStyle={{ color: 'white', fontSize: '20px' }}
                                                                                                                    hintStyle={{ color: 'white', fontSize: '20px' }}
                                                                                                                    value={this.state.formattedCardNumber}
                                                                                                                    onChange={this.handleChange}
                                                                                                                />
                                                                                                            </div>
                                                                                                            <div style={{ width: '20%', textAlign: 'right' }}>
                                                                                                                <DecimalInput
                                                                                                                    name={`POSGiftCardAmount`}
                                                                                                                    fullWidth={true}
                                                                                                                    containerName={"containerName"}
                                                                                                                    label={t('pos.payment.amountToReceive')}
                                                                                                                    floatingLabelText={t('pos.payment.amountToReceive')}
                                                                                                                    hintText={t('pos.payment.amountToReceive')}
                                                                                                                    inputStyle={{ color: 'white', fontSize: '20px' }}
                                                                                                                    floatingLabelStyle={{ color: 'white', fontSize: '20px' }}
                                                                                                                    hintStyle={{ color: 'white', fontSize: '20px' }}
                                                                                                                    min={0}
                                                                                                                    max={this.props.posOrder.balanceDue}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </Paper>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) :
                                                                                        <div className="row">
                                                                                            <div className="col-lg-12">
                                                                                                <TextInput name={`${p.name}ReceiptNumber`}
                                                                                                    fullWidth={true}
                                                                                                    label={t('pos.payment.receiptNumber')}
                                                                                                    floatingLabelText={t('pos.payment.receiptNumber')}
                                                                                                    hintText={t('pos.payment.receiptNumber')}
                                                                                                    maxLength="30"
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                )
                                                                        )

                                                                )
                                                        }
                                                    </React.Fragment>
                                                )
                                            case "Online":
                                                return (
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <p>{t('pos.payment.paidOrderConfirm')}</p>
                                                        </div>
                                                    </div>
                                                );
                                            default:
                                                null;
                                        }
                                    })()
                                    : null
                            }
                            <div className="row">
                                <div className="col-lg-12 mt-2">
                                    {
                                        (selectedPaymentMethod.name === 'StoreCredit' || selectedPaymentMethod.name === 'Debit' || selectedPaymentMethod.name === 'Credit') ?
                                            selectedPaymentMethod.name === 'Credit' && !this.props.store.monerisEnabled && !this.props.store.payFirmaEnabled && !this.props.store.paystoneInStoreEnabled && !this.props.store.picPoyntInStoreEnabled && !this.props.store.paymentreeInStoreEnabled && !this.props.store.picEnabled ?
                                                <div>
                                                    <DecimalInput
                                                        autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'StoreCredit' ? true : false}
                                                        name={`${p.name}Amount`}
                                                        fullWidth={true}
                                                        label={t('pos.payment.amount.label')}
                                                        floatingLabelText={t('pos.payment.amount.label')}
                                                        hintText={t('pos.payment.amount.hintText')}
                                                        min={0}
                                                        max={this.props.posOrder.total}
                                                    />
                                                    <SelectInput
                                                        name={`${p.name}CardType`}
                                                        fullWidth={true}
                                                        label={t('pos.payment.cardType')}
                                                        floatingLabelText={t('pos.payment.cardType')}
                                                        defaultValue="1"
                                                        options={cardTypeOptions} />
                                                </div>
                                                :
                                                <DecimalInput
                                                    autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'StoreCredit' ? true : false}
                                                    name={`${p.name}Amount`}
                                                    fullWidth={true}
                                                    label={t('pos.payment.amount.label')}
                                                    floatingLabelText={t('pos.payment.amount.label')}
                                                    hintText={t('pos.payment.amount.hintText')}
                                                    min={0}
                                                    max={this.props.posOrder.total}
                                                /> :
                                            selectedPaymentMethod.name === 'Cash' ?
                                                <DecimalInput
                                                    autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'Cash' ? true : false}
                                                    name={`${p.name}Amount`}
                                                    fullWidth={true}
                                                    label={t('pos.payment.amount.label')}
                                                    floatingLabelText={t('pos.payment.amount.label')}
                                                    hintText={t('pos.payment.amount.hintText')}
                                                    min={0}
                                                    max={1000000}
                                                /> :
                                                selectedPaymentMethod.name === 'GiftCard' && !p.genericGiftCardEnabled ?
                                                    <DecimalInput
                                                        autoFocus={selectedPaymentMethod && selectedPaymentMethod.name === 'StoreCredit' ? true : false}
                                                        name={`${p.name}Amount`}
                                                        fullWidth={true}
                                                        label={t('pos.payment.amount.label')}
                                                        floatingLabelText={t('pos.payment.amount.label')}
                                                        hintText={t('pos.payment.amount.hintText')}
                                                        min={0}
                                                        max={this.props.posOrder.total}
                                                    />
                                                    :
                                                    selectedPaymentMethod.name === 'Online' ?
                                                        <DecimalInput
                                                            autoFocus={false}
                                                            name={`${p.name}Amount`}
                                                            fullWidth={true}
                                                            label={t('pos.payment.amount.online')}
                                                            floatingLabelText={t('pos.payment.amount.online')}
                                                            hintText={t('pos.payment.amount.online')}
                                                            min={0}
                                                            max={this.props.posOrder.total}
                                                            disabled
                                                        /> :
                                                        null
                                    }
                                </div>
                            </div>
                            <React.Fragment>
                                {dynamicChangeDue <= 0 ? null : (

                                    <div className="row" >
                                        <div className="col-lg-10">
                                            <span style={{ fontSize: "150%", marginTop: "0px" }} className="pull-left pos-summary order_details_balance green-text"><strong>{t('pos.payment.changeDue')}</strong></span>
                                        </div>
                                        <div className="col-lg-2">
                                            <span style={{ fontSize: "150%", marginTop: "0px" }} className="pull-right pos-summary value_nowrap order_details_balance green-text">
                                                <strong>$ {dynamicChangeDue.toFixed(2)}</strong>
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                            <div className="row">
                                <div className="col-lg-6">
                                    <CustomButton
                                        type="FlatButtonPrimary"
                                        name={"cancelPaymentButton"}
                                        fullWidth={true}
                                        className="pull-right vertical-space btn-border-pos remove-btn-pos"
                                        label={t('common.cancel')}
                                        primary={true}
                                        onTouchTap={() => this.onPaymentSelect(null)} />

                                </div>
                                <div className="col-lg-6">
                                    <CustomButton
                                        type="RaisedButton"
                                        name={"confirmPaymentButton"}
                                        fullWidth={true}
                                        className="pull-right vertical-space btn-confirm-pos btnNewBrandPOS"
                                        label={t('common.confirm')}
                                        primary={true}
                                        onTouchTap={() => this.checkOrderUpdateTime()} />
                                </div>
                            </div>
                        </div>
                    ) :
                        (
                            <div className="btnPaymentContainer">
                                {/* Payment Buttons Start---------------------------------------------------------------------------------------------- */}
                                {!(p.fulfillmentEnabled && !p.fulfillmentPayFirst && p.posOrder && !p.posOrder.fulfillmentDone) && (
                                    <React.Fragment>
                                        {orderIsCompleted ? null :
                                            p.payments.map((item, index) => {
                                                const currentBtn = btnPaymentOptions.find(i => i.value === item.name);
                                                return item.status === 'Active' || item.status == 1 ?
                                                    (
                                                        <div id={item.name} className="btns-payment" key={index} >
                                                            <Button
                                                                disabled={disableAllButtons || !doesOrderExist}
                                                                sx={{ color: "#FFFFFF" }}
                                                                variant="contained"
                                                                fullWidth={true}
                                                                className="pull-right vertical-space d-flx justify-content-center"
                                                                onClick={() => this.onPaymentSelect(item)}
                                                            >{currentBtn ? currentBtn.text : item.name}</Button>
                                                        </div>
                                                    ) : null
                                            })
                                        }
                                    </React.Fragment>
                                )}
                                {orderIsCompleted ? null :
                                    p.stackDiscountsEnabled ||
                                        p.posOrder && p.discountCondition && (!p.posOrder.hasDiscounts
                                            || (validProductsFromOrder.length !== validProductsFromOrder.filter(item => item.discountType !== null).length && validProductsFromOrder.filter(item => item.discountType !== null).length > 0)) || this.props.alpineIQApiKey ? (
                                        <div className="col-lg-12">
                                            <CustomButton
                                                type="FlatButtonPrimary"
                                                name={"discountButton"}
                                                disabled={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist}
                                                fullWidth={true}
                                                className="pull-right vertical-space btn-border-pos d-flx justify-content-center"
                                                label={
                                                    <span className={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist ? "btn-disabled-text" : ""}>
                                                        {t('pos.payment.applyDiscount')}
                                                    </span>}
                                                onTouchTap={() => this.openDiscountDialog()} />
                                        </div>
                                    ) : null
                                }
                                {orderIsCompleted ? null :
                                    p.posOrder && p.posOrder.hasDiscounts ? (
                                        <div className="col-lg-12">
                                            <CustomButton
                                                type="FlatButtonPrimary"
                                                name={"discountButton"}
                                                disabled={(disableAllButtons || orderHasPayment) || !doesOrderExist}
                                                fullWidth={true}
                                                className={"pull-right vertical-space btn-border-pos remove-btn-pos d-flx justify-content-center text-white"}
                                                label={
                                                    <span className={(disableAllButtons || orderHasPayment) || !doesOrderExist ? "btn-disabled-text" : ""}>
                                                        {t('pos.payment.removeDiscount')}
                                                    </span>}
                                                onTouchTap={() => this.openRemoveDiscountDialog()} />
                                        </div>
                                    ) : null
                                }
                                {orderIsCompleted ? null :
                                    this.props.store.shippingCostEnabled && p.posOrder ? (
                                        <div className="col-lg-12">
                                            <CustomButton
                                                type="FlatButtonPrimary"
                                                name={"shippingCostButton"}
                                                disabled={!doesOrderExist}
                                                fullWidth={true}
                                                className="pull-right vertical-space btn-border-pos"
                                                label={t('pos.payment.addEditShippingCost')}
                                                onTouchTap={() => this.openAddShippingCostDialog()}
                                            />
                                        </div>
                                    ) : null
                                }
                                {
                                    this.props.inStoreTipEnabled && p.posOrder && !p.posOrder.tipAmount ?
                                        (
                                            <div className="col-lg-12">
                                                {<CustomButton
                                                    type="FlatButtonPrimary"
                                                    name={"shippingCostButton"}
                                                    disabled={!doesOrderExist}
                                                    fullWidth={true}
                                                    className="pull-right vertical-space btn-border-pos"
                                                    label={t('pos.payment.addEditTipAmount')}
                                                    onTouchTap={() => this.openAddTipAmountDialog()}
                                                />}
                                            </div>
                                        ) : null
                                }
                                {orderIsCompleted ? null :
                                    <div className="col-lg-12">
                                        <CustomButton
                                            type="FlatButtonPrimary"
                                            name={"emailInvoiceButton"}
                                            disabled={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist}
                                            fullWidth={true}
                                            className="pull-right vertical-space btn-border-pos d-flx justify-content-center"
                                            label={
                                                <span className={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist ? "btn-disabled-text" : ""}>
                                                    {t('pos.payment.emailInvoice')}
                                                </span>}
                                            onTouchTap={() => this.props.openEmailInvoiceDialog()} />
                                        <CustomButton
                                            type="FlatButtonPrimary"
                                            name={"printInvoiceButton"}
                                            disabled={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist}
                                            fullWidth={true}
                                            className="pull-right vertical-space btn-border-pos d-flx justify-content-center"
                                            label={
                                                <span className={(disableAllButtons || (p.posOrder.payments && (p.posOrder.payments.length > 0))) || !doesOrderExist ? "btn-disabled-text" : ""}>
                                                    {t('pos.payment.printInvoice')}
                                                </span>}
                                            onTouchTap={() => this.props.printReceipt(null, 1)} />
                                    </div>

                                }
                                {
                                    validProductsForRefund.length > 0 ? (

                                        <div className="col-lg-12">
                                            <div className='refundBtn'>
                                                <CustomButton
                                                    type="FlatButtonPrimary"
                                                    name={"refundButton"}
                                                    fullWidth={true}
                                                    className="pull-right vertical-space text-xl refundBtn-inner refundBtn"
                                                    style={disableRefundButton ? { color: '#0000004d', cursor: 'default' } : {}}
                                                    onTouchTap={() => this.openRefundDialog()}
                                                    label={t('pos.payment.refund')}
                                                />
                                            </div>
                                        </div>

                                    ) : null
                                }
                                {
                                    this.props.isMedical && !orderIsCompleted ? (
                                        <div className="col-lg-12">
                                            <CustomButton
                                                type="FlatButtonPrimary"
                                                name={"taxFreeButton"}
                                                fullWidth={true}
                                                className="pull-right vertical-space btn-border-pos"
                                                label={t('pos.payment.taxFree')}
                                                disabled={(disableAllButtons || orderHasPayment) || !doesOrderExist}
                                                onTouchTap={() => this.props.clearTax(this.props.posOrder.id)} />
                                        </div>
                                    ) : null
                                }
                                {
                                    p.posOrder && p.posOrder.status == "Opened" && p.fulfillmentEnabled && !p.posOrder.fulfillmentDone && !p.fulfillmentPayFirst && (
                                        <div className="col-lg-12">
                                            <CustomButton
                                                type="FlatButtonPrimary"
                                                name={"sendToFulfillmentButton"}
                                                className="pull-right vertical-space btn-border-pos"
                                                label={t('pos.payment.sendToFulfillment')}
                                                onTouchTap={() => this.sendToFulfillment()} />
                                        </div>
                                    )
                                }
                            </div>
                        )
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        store: state.common.store,
        payments: state.entity.paymentsList,
        numberOfCopies: state.common.applicationSettings ? state.common.applicationSettings.numberOfCopies : 1,
        amount: parseFloat(state.form[`${ownProps.name}Amount`]) || 0,
        receiptNumber: state.form[`${ownProps.name}ReceiptNumber`] || null,
        storeCreditCode: state.form[`${ownProps.name}StoreCreditCode`] || null,
        posPaymentscardType: state.form[`${ownProps.name}CardType`] || NoCardType,
        posOrder: state.entity.posOrder,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        userPin: JSON.parse(sessionStorage.getItem('pinUser')) ? JSON.parse(sessionStorage.getItem('pinUser')) : state.entity.pin,
        branchId: state.common.branchId,
        posCreated: state.entity.posCreated,
        pinPadId: state.entity.pinPadId,
        pinPadIntegrated: state.entity.pinPadIntegrated,
        isMedical: state.common.applicationSettings.isMedical,
        shippingCost: state.form[`posDialogAddShippingCostValue`] || 0,
        tipAmount: state.form[`posDialogAddTipAmountValue`] || 0,
        model: selectRefundProducts(state, `posDialogRefund`),
        picStatus: state.form[`picStatus`],
        globalStatus: state.form[`globalStatus`],
        fulfillmentEnabled: state.common.applicationSettings.fulfillmentEnabled,
        fulfillmentPayFirst: state.common.applicationSettings.fulfillmentPayFirst,
        giftCardModel: giftCardPaymentModel(state, 'POSPayments'),
        giftCardPurchaseTime: state.entity.giftCardPurchaseTime ? state.entity.giftCardPurchaseTime : null,
        giftCardPurchaseResponse: state.entity.giftCardPurchaseResponse || null,
        monerisGiftCardEnabled: state.common.applicationSettings.monerisGiftCardEnabled,
        proceddMethod: state.form[`${ownProps.name}processMethod`],
        paystoneGiftCardEnabled: state.common.applicationSettings.paystoneGiftCardEnabled,
        birchmountGiftCardEnabled: state.common.applicationSettings.birchmountGiftCardEnabled,
        cashFlow: state.entity.cashFlow,
        paystoneGiftCardPurchaseTime: state.entity.paystoneGiftCardPurchaseTime,
        paystoneGiftCardPurchaseData: state.entity.paystoneGiftCardPurchaseData,
        birchmountGiftCardPurchaseData: state.entity.birchmountGiftCardPurchaseData,
        birchmountGiftCardPurchaseTime: state.entity.birchmountGiftCardPurchaseTime,
        paystoneCardNumber: state.form[`${ownProps.name}PaystoneGiftCardNumber`],
        returnMethod: state.form[`${ownProps.name}RefundMethod`],
        birchmountGiftCardNumber: state.form[`${ownProps.name}BirchmountGiftCardNumber`],
        birchmountGiftCardPIN: state.form[`${ownProps.name}BirchmountGiftCardPIN`],
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || "",
        alpineIQwalletCode: state.common.applicationSettings.alpineIQwalletCode || "",
        wallet: state.entity.alpineIQwallet,
        noSalesAllowedAfterStoreHours: state.common.applicationSettings.noSalesAllowedAfterStoreHours,
        storeOpenHour: state.common.applicationSettings.storeOpenHour,
        storeCloseHour: state.common.applicationSettings.storeCloseHour,
        discountCondition: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanApplyDiscount")),
        inStoreTipEnabled: state.common.applicationSettings.inStoreTipEnabled,
        sendToFulfillmentSuccess: state.entity.sendToFulfillmentSuccess,
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
        genericGiftCardEnabled: state.common.applicationSettings.genericGiftCardEnabled,
        giftCardPaymentAmount: state.form.POSGiftCardAmount || null,
        giftCardNumber: state.form.POSGiftCardCardNumber || null,
        giftCardPurchaseFailResponse: state.entity.giftCardPurchaseFailResponse,
        giftCardPurchaseFailResponseTime: state.entity.giftCardPurchaseFailResponseTime,
        giftCardPurchaseSuccessResponse: state.entity.giftCardPurchaseSuccessResponse,
        giftCardPurchaseSuccessResponseTime: state.entity.giftCardPurchaseSuccessResponseTime,
        posOrderCheckUpateTimePassed: state.entity.posOrderCheckUpateTimePassed,
        priceMatchPlusPercentage: state.entity.priceMatchPlusPercentage,
        pinpadPaymentApprovalUsername: state.form['PinpadPaymentApprovalUsername'],
        pinpadPaymentApprovalPassword: state.form['PinpadPaymentApprovalPassword'],
        pinpadPaymentApprovalPinCode: state.form['PinpadPaymentApprovalPinCode'],
        managerApprovalUserId: state.entity.managerApprovalUserId,
        managerApprovalTimeStamp: state.entity.managerApprovalTimeStamp,
        managerApprovalSuccess: state.entity.managerApprovalSuccess,
        ipAddress: state.entity.ipAddress,
        adyenInStorePaymentAPIKey: state.common.applicationSettings.adyenInStorePaymentAPIKey || "",
        adyenPaymentResponse: state.entity.adyenPaymentResponse || null,
        adyenPaymentSuccessTime: state.entity.adyenPaymentSuccessTime || null,
        adyenRefundSuccessTime: state.entity.adyenRefundSuccessTime || null,
        adyenRefundResponse: state.entity.adyenRefundResponse || null,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        alpineIQviewWallet: (model) => dispatch(alpineIQviewWallet(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        addPaymentToOrder: (model) => dispatch(addPaymentToOrder(model)),
        formError: (name, error) => dispatch(formError(name, error)),
        clearTax: (orderId) => dispatch(clearTax(orderId)),
        addShippingCost: (orderId, shippingCost, modifiedDate) => dispatch(addShippingCost(orderId, shippingCost, modifiedDate)),
        addTipAmount: (orderId, tipAmount, modifiedDate) => dispatch(addTipAmount(orderId, tipAmount, modifiedDate)),
        addRefund: (orderId, model) => dispatch(addRefundOrder(orderId, model, `posDialogRefund`)),
        sendOrderToFulFillment: (order) => dispatch(sendOrderToFulFillment(order)),
        giftCardPurchase: (model) => dispatch(giftCardPurchase(model)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        paystoneGiftCardPurchase: (model) => dispatch(paystoneGiftCardPurchase(model)),
        birchmountGiftCardPurchase: (model) => dispatch(birchmountGiftCardPurchase(model)),
        showError: (message) => dispatch(showError(message)),
        chargeGiftCard: (model) => dispatch(chargeGiftCard(model)),
        checkOrderUpdateTime: (orderId, modifiedDate) => dispatch(checkOrderUpdateTime(orderId, modifiedDate)),
        clearPriceMatchRows: () => dispatch(clearPriceMatchRows()),
        getManagerApproval: (model) => dispatch(getManagerApproval(model)),
        adyenPaymentRequest: (model) => dispatch(adyenPaymentRequest(model)),
        adyenRefundRequest: (model) => dispatch(adyenRefundRequest(model)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSPayment));
